import { ROUTES } from "../constants/routes";
import { ContentType, GroupModelType, GroupPreviewPage, HomepageSectionType, Orientation, PurchaseType, UserRole, } from "../types/global";
// * =============================== [ DATA FORMATTING FUNCTIONS ]
export function formatSchedulingDate(datetime, timezone) {
    if (!datetime || !timezone)
        return null;
    const datetimeForIso = datetime.split("+")[0].replace(" ", "T");
    let timezoneForIso = timezone;
    if (timezoneForIso == "Local") {
        timezoneForIso = "";
    }
    else {
        timezoneForIso = timezoneForIso.replace("GMT", "");
        if (!timezoneForIso.includes(":")) {
            timezoneForIso += ":00";
        }
    }
    const date = new Date(`${datetimeForIso}${timezoneForIso}`);
    const now = new Date();
    if (date.getTime() < now.getTime()) {
        return null;
    }
    return date;
}
export function sectionToContentType(type) {
    switch (type) {
        case HomepageSectionType.Categories:
            return ContentType.Folder;
        case HomepageSectionType.ComingSoon:
            return ContentType.ComingSoon;
        case HomepageSectionType.Custom:
            return ContentType.Video;
        case HomepageSectionType.Lives:
            return ContentType.Livestream;
        case HomepageSectionType.News:
            return ContentType.Video;
        case HomepageSectionType.Reels:
            return ContentType.Reels;
        case HomepageSectionType.Shorts:
            return ContentType.Shorts;
        default:
            return ContentType.Video;
    }
}
/**
 * Formats a content duration into a human-readable string.
 *
 * @param duration - Duration in seconds.
 * @param t - Translation function returned by `useTranslate`.
 */
export function formatContentDuration(duration, t) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;
    if (hours == 0 && minutes == 0) {
        return `${seconds}${t("abbr-seconds")}`;
    }
    if (hours > 0) {
        if (minutes < 5) {
            return `${hours}${t("abbr-hours")}`;
        }
        return `${hours}${t("abbr-hours")} ${minutes}${t("abbr-minutes")}`;
    }
    return `${minutes}${t("abbr-minutes")}`;
}
// * =============================== [ REDIRECT URL GETTERS ]
export function getHeroSectionRedirectUrl(content, previewPage) {
    //LIB 10/08 al fine di risolvere il bug 9191 la logica del guarda ora è stata inpostata così.
    //capire se si può migliorare con sviluppi successi
    switch (content.content_type) {
        case ContentType.Livestream:
            return previewPage === GroupPreviewPage.Enabled
                ? ROUTES.VIEWINTERMIDIATE(content.content_id)
                : ROUTES.WATCH_VIDEO(content.content_id, HomepageSectionType.Lives);
        case ContentType.Fastchannels:
            return previewPage === GroupPreviewPage.Enabled
                ? ROUTES.VIEWINTERMIDIATE(content.content_id)
                : ROUTES.WATCH_VIDEO(content.content_id, HomepageSectionType.Lives);
        case ContentType.Video:
            return previewPage === GroupPreviewPage.Enabled
                ? ROUTES.VIEWINTERMIDIATE(content.content_id)
                : Number(content.content_vertical) == 0
                    ? ROUTES.WATCH_VIDEO(content.content_id, HomepageSectionType.News)
                    : ROUTES.WATCH_REEL(content.content_id);
        // TODO: CASO ANCORA DA GESTIRE, NON CI DEVE ESSERE ROUTES.VIEWFOLDER. NEL FUTURO SARA UNA PAGINA REACT
        case ContentType.Folder:
            return ROUTES.VIEWFOLDER(content.content_id);
        // ! CASO ANCORA DA GESTIRE, NON CI DEVE ESSERE ROUTES.VIEWMEDIA ED ENTRAMBI DEVONO PRENDERE ANCHE L'ID DELLA PLAYLIST
        case ContentType.Playlist:
            return Number(content.content_vertical) == 0
                ? ROUTES.WATCH_VIDEO(content.playlist_first_video_id, HomepageSectionType.Custom, 1, content.content_id)
                : ROUTES.WATCH_REEL(content.content_id);
        case ContentType.Reels:
        case ContentType.Shorts:
            return ROUTES.WATCH_REEL(content.content_id);
        case ContentType.ComingSoon: {
            if (content.true_content_type == ContentType.Video) {
                return Number(content.content_vertical) == 0
                    ? previewPage === GroupPreviewPage.Enabled
                        ? ROUTES.VIEWINTERMIDIATE(content.content_id)
                        : ROUTES.WATCH_VIDEO(content.content_id, HomepageSectionType.News)
                    : ROUTES.WATCH_REEL(content.content_id);
            }
            else if (content.true_content_type == ContentType.Livestream ||
                content.true_content_type == ContentType.Fastchannels) {
                return previewPage === GroupPreviewPage.Enabled
                    ? ROUTES.VIEWINTERMIDIATE(content.content_id)
                    : ROUTES.WATCH_VIDEO(content.content_id, HomepageSectionType.Lives);
            }
        }
        default:
            return undefined;
    }
}
export function getHeroSectionContentPurchaseTypes(buttons, contentId) {
    let purchaseTypes = {
        [PurchaseType.Buy]: null,
        [PurchaseType.Rent]: null,
        [PurchaseType.Subscribe]: null,
    };
    if (buttons["buy_button"] == 1 || buttons["coin_button"]) {
        purchaseTypes[PurchaseType.Buy] =
            contentId != null ? ROUTES.VIEWINTERMIDIATEPAY(contentId) : null;
    }
    if (buttons["rent_button"] == 1) {
        purchaseTypes[PurchaseType.Rent] =
            contentId != null ? ROUTES.VIEWINTERMIDIATEPAY(contentId) : null;
    }
    if (buttons["subscribe_button"] == 1) {
        purchaseTypes[PurchaseType.Subscribe] =
            contentId != null
                ? ROUTES.SUBSCRIBTION(contentId)
                : ROUTES.SUBSCRIBTION();
    }
    return purchaseTypes;
}
export function getContentRedirectUrl(locked, item, sectionType, sectionOrientation, previewEnabled, sectionData) {
    const playlistId = sectionData?.is_playlist
        ? (sectionData.rel ?? null)
        : null;
    if (locked) {
        return ROUTES.VIEWINTERMIDIATE(item.id, playlistId);
    }
    if (sectionType === HomepageSectionType.Lives) {
        return previewEnabled === GroupPreviewPage.Enabled
            ? ROUTES.VIEWINTERMIDIATE(item.id)
            : ROUTES.WATCH_VIDEO(item.id, HomepageSectionType.Lives);
    }
    if (sectionOrientation === Orientation.Landscape) {
        return previewEnabled === GroupPreviewPage.Enabled
            ? ROUTES.VIEWINTERMIDIATE(item.id)
            : ROUTES.WATCH_VIDEO(item.id, sectionType == HomepageSectionType.News
                ? HomepageSectionType.News
                : HomepageSectionType.Custom, sectionData?.is_playlist, sectionData?.rel);
    }
    return ROUTES.WATCH_REEL(item.id, playlistId);
}
export function getContentPurchaseTypes(content, userData, modelData) {
    const locked = Boolean(content.locked);
    if (!modelData || !locked) {
        return {
            [PurchaseType.Buy]: null,
            [PurchaseType.Rent]: null,
            [PurchaseType.Subscribe]: null,
        };
    }
    const modelType = modelData.type;
    const isPurchase = (Boolean(content.info.buy_tariff_id) && isPayPerViewModel(modelType)) ||
        (Boolean(content.info.number_of_coins) && isCoinModel(modelType));
    const isRent = Boolean(content.info.rent_tariff_id) && isPayPerViewModel(modelType);
    const isSubscriptionModelVal = isSubscriptionModel(modelType);
    const isBundle = content.info.bundles_ids?.length > 0 && isSubscriptionModelVal;
    const isFullSubscription = modelData.sub_ids?.length > 0 && isSubscriptionModelVal;
    if (!userData) {
        return {
            [PurchaseType.Buy]: isPurchase
                ? ROUTES.VIEWINTERMIDIATEPAY(content.id)
                : null,
            [PurchaseType.Rent]: isRent
                ? ROUTES.VIEWINTERMIDIATEPAY(content.id)
                : null,
            [PurchaseType.Subscribe]: isBundle || isFullSubscription ? ROUTES.SUBSCRIBTION(content.id) : null,
        };
    }
    else if (userData?.role < UserRole.Admin) {
        let purchaseTypes = {
            [PurchaseType.Buy]: null,
            [PurchaseType.Rent]: null,
            [PurchaseType.Subscribe]: null,
        };
        if (isPurchase) {
            purchaseTypes[PurchaseType.Buy] = userData.purchase?.videos_ids.includes(content.id)
                ? null
                : ROUTES.VIEWINTERMIDIATEPAY(content.id);
        }
        if (isRent) {
            purchaseTypes[PurchaseType.Rent] = userData.purchase?.videos_ids.includes(content.id)
                ? null
                : ROUTES.VIEWINTERMIDIATEPAY(content.id);
        }
        if (isBundle) {
            purchaseTypes[PurchaseType.Subscribe] =
                userData.purchase?.bundles_ids.some((id) => content.info?.bundles_ids.includes(id))
                    ? null
                    : ROUTES.VIEWINTERMIDIATEPAY(content.id);
        }
        // Se ci sta Bundle ma non FullSubscription allora lascia l'url del bundle
        if (isFullSubscription) {
            purchaseTypes[PurchaseType.Subscribe] = userData.purchase?.sub_ids.some((id) => modelData?.sub_ids.includes(id))
                ? purchaseTypes[PurchaseType.Subscribe]
                : ROUTES.VIEWINTERMIDIATEPAY(content.id);
        }
        return purchaseTypes;
    }
    return {
        [PurchaseType.Buy]: null,
        [PurchaseType.Rent]: null,
        [PurchaseType.Subscribe]: null,
    };
}
// * =============================== [ CHECK FUNCTIONS ]
export function isSubscriptionModel(type) {
    return [
        GroupModelType.SUB,
        GroupModelType.S_A,
        GroupModelType.S_A_P_T,
        GroupModelType.S_C,
        GroupModelType.S_A_C,
    ].includes(type);
}
export function isPayPerViewModel(type) {
    return [
        GroupModelType.TVOD,
        GroupModelType.PPV,
        GroupModelType.S_PT,
        GroupModelType.S_A_P_T,
    ].includes(type);
}
export function isAdsModel(type) {
    return [
        GroupModelType.S_A,
        GroupModelType.S_A_P_T,
        GroupModelType.AD,
        GroupModelType.S_A_C,
    ].includes(type);
}
export function isCoinModel(type) {
    return [GroupModelType.S_C, GroupModelType.S_A_C].includes(type);
}
export function checkContentLockedForUser(content, userData, modelData) {
    const locked = Boolean(content.info.locked);
    if (!modelData || !locked) {
        return false;
    }
    const modelType = modelData.type;
    const isPurchase = ((Boolean(content.info.buy_tariff_id) ||
        Boolean(content.info.rent_tariff_id)) &&
        isPayPerViewModel(modelType)) ||
        (Boolean(content.info.number_of_coins) && isCoinModel(modelType));
    const isSubscriptionModelVal = isSubscriptionModel(modelType);
    const isBundle = content.info.bundles_ids?.length > 0 && isSubscriptionModelVal;
    const isFullSubscription = modelData.sub_ids.length > 0 && isSubscriptionModelVal;
    if (!userData) {
        return isPurchase || isBundle || isFullSubscription;
    }
    else if (userData?.role < UserRole.Admin) {
        const userVideoIDs = userData.purchase?.videos_ids;
        // se l'utente ha gia acquistato il video, non deve essere locked
        if (userVideoIDs?.includes(content.id)) {
            return false;
        }
        if (isFullSubscription) {
            return !userData.purchase?.sub_ids.some((id) => modelData.sub_ids.includes(id));
        }
        else if (isBundle) {
            return !userData.purchase?.bundles_ids.some((id) => content.info.bundles_ids.includes(id));
        }
        else if (isPurchase) {
            return !userData.purchase?.videos_ids.includes(content.id);
        }
    }
    return false;
}
